/** Path prefixes for optional modules gated by public feature flags. */

export type OptionalModuleNavKey = 'group_trip' | 'listing' | 'blog' | 'partner_offer' | 'colony' | 'lottery' | 'match_event'

export function optionalModuleKeyForPath(path: string): OptionalModuleNavKey | null {
  if (path === '/lottery' || path.startsWith('/lottery/')) return 'lottery'
  if (path === '/match-event' || path.startsWith('/match-event/')) return 'match_event'
  if (path === '/group-trips' || path.startsWith('/group-trips/') || path.startsWith('/me/group-trips')) {
    return 'group_trip'
  }
  if (path === '/listings' || path.startsWith('/listings/')) return 'listing'
  if (path === '/blog' || path.startsWith('/blog/')) return 'blog'
  if (
    path === '/partner-offers' ||
    path.startsWith('/partner-offers/') ||
    path.startsWith('/me/partner-offers')
  ) {
    return 'partner_offer'
  }
  if (path === '/colony' || path.startsWith('/colony/') || path.startsWith('/me/colony-registrations')) {
    return 'colony'
  }
  return null
}

export type OptionalModuleFlags = Record<OptionalModuleNavKey, boolean>

export function isOptionalModulePathVisible(path: string, flags: OptionalModuleFlags): boolean {
  const key = optionalModuleKeyForPath(path)
  if (key === null) return true
  return flags[key]
}
